import { Badge } from '@/components/ui/badge';
import type { NewPayment } from '@/models/payments';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';
import { displayCurrency, displayDate } from '../../../../utils/format.utils';

export const paymentsRegisterColumns: ColumnDef<NewPayment>[] = [
  {
    accessorKey: 'client',
    header: 'Customer Name',
    enableSorting: false,
    cell: ({ getValue }) => {
      const name = getValue() as string;
      return h('div', name);
    },
  },
  {
    accessorKey: 'orderReference',
    header: 'Order Reference',
    enableSorting: false,
    cell: ({ getValue }) => {
      const name = getValue() as string;
      return h('div', name);
    },
  },
  {
    accessorKey: 'orderName',
    header: 'Order Name',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'paymentType',
    header: 'Payment Type',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'paymentMethod',
    header: 'Method',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'settlementBatch',
    header: 'Settlement Batch',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'due',
    header: 'Due Date',
    enableSorting: false,
    cell: ({ getValue }) => {
      const dueDate = getValue() as string;
      return h('div', displayDate(dueDate));
    },
  },
  {
    accessorKey: 'amount',
    header: () => {
      return h('div', { class: 'text-right' }, 'Amount');
    },
    enableSorting: false,
    cell: ({ getValue }) => {
      const amount = getValue() as number;
      return h('div', { class: 'text-right' }, displayCurrency(amount));
    },
  },
  {
    accessorKey: 'fee',
    header: () => {
      return h('div', { class: 'text-right' }, 'Fee');
    },
    enableSorting: false,
    cell: ({ getValue }) => {
      const amount = getValue() as number;
      return h('div', { class: 'text-right' }, displayCurrency(amount));
    },
  },
  {
    accessorKey: 'paymentStatus',
    header: 'Status',
    enableSorting: false,
    cell: ({ getValue }) => {
      const state = getValue() as string;
      let variant: 'error' | 'success' | 'warning' | 'info' = 'success';

      if (state === 'FAILED') variant = 'error';
      if (state === 'DUE' || state === 'MISSED') variant = 'warning';
      if (state === 'SETTLED' || state === 'PENDING') variant = 'info';

      return h(Badge, { class: 'text-xs', variant }, () => state);
    },
  },
  {
    accessorKey: 'verifiedAt',
    header: 'Paid Date',
    enableSorting: false,
    cell: ({ getValue }) => {
      const paidDate = getValue() as string;
      return h('div', displayDate(paidDate));
    },
  },
];
